import styled from 'styled-components'

export const BankWrapper = styled.div`
  width: 450px;
  padding: 30px 30px;
  float: right;
  background-color: white;
  height: 100vh;
  .done_btn_wrapper {
    margin-top: 75px;
  }
  .amount_description_wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .amount_text {
      font-weight: 700;
      font-size: ${({ theme }) => theme.fontSize.xl};
      color: ${({ theme }) => theme.colors.black};
      margin: 0;
      padding: 10px 0;
    }

    .description {
      text-align: center;
    }
  }
  .account_details_wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.referralBg};
    padding: 0 10px;
  }

  .copy_container {
    display: flex;

    .copy_text {
      /* padding-right: 10px; */
      width: 80px;
      color: ${({ theme }) => theme.colors.navyBlue};
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .list_wrapper {
    margin-bottom: 20px;
  }
  .list_wrapper p {
    font-size: ${({ theme }) => theme.fontSize.s};
  }

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 90%;
    padding: 30px 20px;
  }
`

export const BankModalContainer = styled.div`
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.1);
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
    height: 70%;
  }
`

// export const BankModalBackground = styled.div`
//   width: 500px;
//   background: ${({ theme }) => theme.colors.white};
//   z-index: 9000000000000000000;
//   height: 100%;
//   position: fixed;
//   top: 0;
//   right: 0;

//   @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
//     width: 100%;
//     border-radius: 40px 40px 0px 0px;

//     /* height: 70%; */
//   }
// `

export const BankModalBackground = styled.div`
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.3);
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 12;

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100vw;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    height: 80vh;
  }
`
